var _line, _line2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.353553,
    y1: 0.646447,
    x2: 46.3535,
    y2: 46.6465,
    stroke: "url(#paint0_linear_734_3)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 46.3536,
    y1: 1.35355,
    x2: 0.353549,
    y2: 47.3535,
    stroke: "url(#paint1_linear_734_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_734_3",
    x1: -0.353553,
    y1: 1.35355,
    x2: 45.6464,
    y2: 47.3536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C0EF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_734_3",
    x1: 45.6464,
    y1: 0.646447,
    x2: -0.353558,
    y2: 46.6464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C0EF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroX);
export default __webpack_public_path__ + "static/media/intro-x.423f54c6d1adcb94a4b8251b3215ba46.svg";
export { ForwardRef as ReactComponent };